import { inputMask, noSpecialCharacters, onlyNumbers } from './formUtils';

// Checks whether or not the given shipping address object has been populated
export const hasShippingAddress = addresses => !!(addresses && (addresses.otherAddresses.length || Object.keys(addresses.defaultAddress).length));

// Allows zip code formatter to be specific to a country
function formatZipcode(countryCode, value) {
  if(countryCode === 'US'){
    let output = inputMask(onlyNumbers(value), '*****-****');
    const len = value.length;
    if (value.charAt(len - 1) === '-' && len === 6) output += '-';
    return output;
  } else {
    return noSpecialCharacters(value);
  }
}

export function getZipFormatterForCountry(countryCode) {
  return formatZipcode.bind(null, countryCode);
}

export function getZipPattern(countryCode){
  if(countryCode === 'US'){
    return '.{5,10}';
  } else {
    return '.{0,10}';
  }
}

export function getShippingAddressPayload(payload) {
  const data = {
    type: payload?.type,
    countryCode: payload?.countryCode,
    firstName: payload?.firstName,
    lastName: payload?.lastName,
    line1: payload?.line1,
    city: payload?.city,
    countrySubdivision: payload?.countrySubdivision,
    postalCode: payload?.postalCode,
    active: true,
    defaultAddress: false,
    phoneNumber: payload?.phoneNumber
  };

  if (payload?.type !== 'MILITARY') {
    if (payload?.line2 != null) data.line2 = payload.line2;
  } else {
    data.countryCode = 'US';
  }

  if (payload?.type === 'COMMERCIAL') {
    data.firstName = undefined;
    data.lastName = undefined;
    data.organizationName = payload?.organizationName;
  }

  if (payload?.defaultAddress) data.defaultAddress = true;
  if (payload?.id) data.id = payload.id;
  return data;
}

export function getCountryNameByCode(code, countryData) {
  const countries = countryData.countries;
  const country = countries.find(c => c.code === code.toUpperCase());
  return country.name;
}

export function getStateNameByCode(code, countryCode, countryData) {
  const states = countryData.states[countryCode];
  const militaryStates = countryData.militaryLocations?.subDivisions;
  let state = militaryStates.find(st => st.code === code.toUpperCase());
  if (!state) state = states.find(st => st.code === code.toUpperCase());
  return state.name;
}

export function getCityName(cityName, countryData) {
  const militaryCities = countryData.militaryLocations?.cities;
  const city = militaryCities.find(c => c.code === cityName.toUpperCase());
  return city && city.name || cityName;
}

export function formatSuggestionData(suggestion, countryData, countryCode) {
  const suggestionData = {};

  if (!countryData.countries.length || !countryData.states[countryCode] || !countryData.states[countryCode].length ||
      !countryData.militaryLocations.cities.length || !countryData.militaryLocations.subDivisions.length) return suggestionData;

  Object.keys(suggestion).forEach(key => {
    switch (key) {
      case 'cityName': suggestionData[key] = getCityName(suggestion[key], countryData); break;
      //case 'countrySubdivisionCode': suggestionData[key] = getStateNameByCode(suggestion[key], countryCode, countryData); break;
      case 'countrySubdivisionCode': suggestionData[key] = suggestion[key].toUpperCase(); break;
      default: suggestionData[key] = suggestion[key];
    }
  });

  return suggestionData;
}
